module.exports = __webpack_public_path__ + "img/bet10.68d5db9c.png";